import React, { useState, useEffect } from 'react';
import '../MoveHomepage.css';
import { useNavigate } from 'react-router-dom';
import MoveHomePageIntro from './MoveHomePageIntro';
import LogoSlideshow from '../Logoslideshow';
import CarImageComponent from '../CarImageComponent';
import WhatsAppChat from './Whatsapp';
import SignupPage from '../../Transport Account/SignupForm';
import MoveRatingWithFeedback from '../../Reviews/ReviewsTransport';
import MoveBackground from '../RadialGradientComponent';
import AboutUs from './Aboutus';
import TextEditor from './TextAreaformatting';

import { Helmet } from 'react-helmet-async';
import LogisticsHomepage from '../../Transport Account/Logistics Homepage';

function MoveHomePage() {
  // State to store fetched car details
  
  
  const [selectedOption, setSelectedOption] = useState('');
  const navigate = useNavigate(); // Hook for navigation

  const handleSelectChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);

    // Navigate based on the selected option
    if (value === 'move') {
      navigate('/move'); // Navigate to the Move page
    } else if (value === 'vehicle-movement') {
      navigate('/subcontractform'); // Navigate to the Vehicle Movement page
    }
};

  return (
    <>
     <Helmet>
        <title>Zoom Autos - Your Trusted Logistics Partner</title>
        <meta name="description" content="Reliable car transport and vehicle delivery services across the UK. Zoom Autos ensures secure, fast, and professional vehicle movement nationwide." />
<meta name="keywords" content="car transport, vehicle delivery, vehicle movement, UK car shipping, car collection service, Zoom Autos logistics" />
<meta name="geo.region" content="GB" />
<meta name="geo.placename" content="London" /> 
<meta name="ICBM" content="51.5074, 0.1278" /> 
      </Helmet>
    <div style={{backgroundColor:'white'}}>
    <CarImageComponent/>
    <MoveBackground/>
    <div className="homepage-container">

    
<LogoSlideshow/>    
</div>
      <MoveHomePageIntro/>
      
      <MoveRatingWithFeedback/>
      
      <WhatsAppChat/>
      
      {/* <div>
      
      <select
        id="dropdown"
        value={selectedOption}
        onChange={handleSelectChange}
        style={{
            position: 'fixed',
            bottom: '10%', // Position the button 20px from the bottom
            right: '0%', // Center the button horizontally
            transform: 'translateX(-50%)', // Adjust horizontal centering (optional)
            zIndex: 10,
            width:'max-content'
          }}
      >
        <option value="" disabled>
          Get a Quote
        </option>
        <option value="move">Move</option>
        <option value="vehicle-movement">Vehicle Movement</option>
      </select>
    </div> */}

    </div>
    </>
  );
}

export default MoveHomePage;
